/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';

// https://github.com/okonet/react-dropzone
var Dropzone = require('react-dropzone');

export class UploadLogotype extends React.Component {

  static propTypes = {
    imageSrc: PropTypes.string,
    setLogotype: PropTypes.func.isRequired,
    deleteLogotype: PropTypes.func.isRequired,
    logotypePreview: PropTypes.bool,
    logotypeDeleted: PropTypes.bool
  };

  constructor (props) {
    super(props);

    this.state = {
      files: [],
      imageSrc: this.props.imageSrc,
      invalidFile: false,
      logotypePreview: false,
      logotypeDeleted: false
    };

    this.showPreview = this.showPreview.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.logotypeDeleted !== this.props.logotypeDeleted) {
      if (nextProps.logotypeDeleted) {
        this.setState({
          imageSrc: ''
        });
      }

      this.setState({
        logotypeDeleted: nextProps.logotypeDeleted
      });
    }

    if (nextProps.logotypePreview !== this.state.logotypePreview) {
      this.setState({
        logotypePreview: nextProps.logotypePreview
      });
    }
  }

  validate (file) {
    var validFileExtensions, validFileSize, typeValid;

    validFileExtensions = ['image/jpeg', 'image/jpg', 'image/png'];
    validFileSize = 2097152;
    typeValid = false;

    if (file.size > validFileSize) {
      return false;
    }

    for (var i = 0; i < validFileExtensions.length; i++) {
      if (file.type === validFileExtensions[i]) {
        typeValid = true;
        break;
      }
    }

    return typeValid;
  }

  onDrop (files) {
    if (this.validate(files[0])) {
      this.setState({
        files: files,
        invalidFile: false
      }, function () {
        this.showPreview(this.state.files[0].preview);
      });

      this.props.setLogotype(files[0]);
    } else {
      this.setState({invalidFile: true});
    }
  }

  showPreview (imageSrc) {
    this.setState({
      imageSrc: imageSrc,
      logotypePreview: true
    });
  }

  renderLogoDeleteButton () {
    if (this.state.imageSrc && !this.state.logotypePreview) {
      return (
        <button className='menu-btn close-menu' onClick={this.props.deleteLogotype}>
          <div className='cornerimage remove-link'/>
        </button>
      );
    }
  }

  render () {
    return (
      <div className='upload-logotype'>
        <h3><Translate content='USE_LOGO'/></h3>
        <p><Translate content='USE_LOGO_TEXT'/></p>

        <div className='containerdiv'>
          <img src={this.state.imageSrc} alt=''/>
          {this.renderLogoDeleteButton()}
        </div>

        <div className='new_line'/>
        <Dropzone ref='dropzone' onDrop={this.onDrop} className='drop-zone' multiple={false}>
          <div><Translate content='LOGO_INSTRUCTIONS'/></div>
        </Dropzone>
        <p className={this.state.invalidFile ? 'error show' : 'error'}><Translate content='LOGO_ERROR'/></p>
      </div>
    );
  }
}

export default UploadLogotype;



/** WEBPACK FOOTER **
 ** ./src/views/settings/own-employment/upload-logotype/upload-logotype.js
 **/